import ApiConstant from '../../constants/api.constants';
import api from '../api';

export interface NewsData {
  id?: string | number;
  ID?: string | number;
  newsId?: string | number;
  title: string;
  newsDescription?: string;
  description?: string;
  subtitle?: string; 
  imageUrl?: string;
  image?: string; 
  imageFileName?: string;
  containerName?: string;
  isActive?: boolean;
  createdBy?: number;
  createdByName?: string;
  createdDate?: string;
  features?: string[];
  cta?: {
    label: string;
    description: string;
  };
  size?: 'large' | 'medium' | 'small';
}

class NewsService {
 
  async getNewsData(): Promise<NewsData[]> {
    try {
      const response = await api.get(ApiConstant.getNews);
      
      if (response && response.data) {
        const newsItems = Array.isArray(response.data) ? response.data : [response.data];
        return newsItems.map((item: any) => this.mapNewsDtoToNewsData(item));
      }
      
      return [];
    } catch (error) {
      console.error('Failed to load news from API:', error);
      return this.getDefaultNewsData();
    }
  }

  /**
   * Get single news item by ID
   */
  async getNewsById(id: string | number): Promise<NewsData | null> {
    try {
      const newsItems = await this.getNewsData();
      return newsItems.find((item) => item.ID === id || item.id === id || item.newsId === id) || null;
    } catch (error) {
      console.error(`Error fetching news with id ${id}:`, error);
      return null;
    }
  }

  /**
   * Map NewsDTO from backend to NewsData for frontend
   */
  private mapNewsDtoToNewsData(newsDto: any): NewsData {
    return {
      id: newsDto.ID || newsDto.id || newsDto.newsId,
      ID: newsDto.ID,
      newsId: newsDto.ID,
      title: newsDto.title,
      newsDescription: newsDto.newsDescription,
      description: newsDto.newsDescription, 
      image: newsDto.imageUrl,
      imageUrl: newsDto.imageUrl,
      imageFileName: newsDto.imageFileName,
      containerName: newsDto.containerName,
      isActive: newsDto.isActive,
      createdBy: newsDto.createdBy,
      createdByName: newsDto.createdByName,
      createdDate: newsDto.createdDate,
      features: [],
      cta: undefined,
      size: 'medium',
    };
  }

  /**
   * Default fallback data (used when API is unavailable)
   */
  private getDefaultNewsData(): NewsData[] {
    return [
      {
        newsId: 1,
        id: "1",
        title: "Sanjeevini Kashaya",
        subtitle: "Premium Wellness",
        description: "Sanjeevini Kashaya powder is a premium Ayurvedic formulation designed to support comprehensive wellness and vitality.",
        image: "https://farm2me.azurewebsites.net/images/farm2me/Banner.jpg",
        imageUrl: "https://farm2me.azurewebsites.net/images/farm2me/Banner.jpg",
        isActive: true,
        features: [
          "Supports Diabetic Health",
          "Balances BP & Heart Health",
          "Improves Digestion & Gut Strength",
          "Boosts Immunity Naturally",
          "Anti-Inflammatory & Detoxifying",
        ],
        cta: {
          label: "Shop Now",
          description: "Begin each day with the designated millet pack on an empty stomach",
        },
        size: 'large',
      }
    ];
  }
}

export default new NewsService();
